<drdp-add-edit-table [dataSource]="dataSource" viewIcon="uil uil-notes text-drdpblue-300" [showIconInfo]="true"
  [columns]="tableColumns" [tableData]="students" (iconActionItem)="onReviewEvidence($event)">
</drdp-add-edit-table>
